import styles from './BrainChat.module.scss'
import {
  Link, useParams
} from "react-router-dom";
import { BiSupport } from "react-icons/bi";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { AiOutlineSend } from "react-icons/ai";
import { RiArrowGoBackFill } from "react-icons/ri";
import { AuthContext } from '../../contexts/AuthContext';
import bg_box from '../../images/bg_box.png'
import bg_main from '../../images/bg_logado.png'
import { useContext, useEffect, useState, useRef } from 'react';
import bgchat from '../../images/bg_chat.png'
import api from '../../services/api'
import moment from 'moment/moment';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom'
import { BiSolidDirections } from "react-icons/bi";
import { MdOutlineOpenInFull } from "react-icons/md";



function BrainChat() {
  const navigate = useNavigate();
  const [chat, setChat] = useState([]);
  const { id } = useParams();
  const [message, setMessage] = useState('');
  const { user, getToken } = useContext(AuthContext);
  const chatScroll = useRef(null);
  const [isActive, setIsActive] = useState(true);
  const [loading, setLoading] = useState(true);
  const [loadingChat, setLoadingChat] = useState(false);
  const [faqs, setFaqs] = useState([])
  const [faqsHistory, setFaqsHistory] = useState([])
  const [chatOpen, setChatOpen] = useState(false)
  const [showChat, setShowChat] = useState(false)

  useEffect(() => {
    api.post('/countdown')
    .then((res) => {
      console.log(res.data.retorno)
      if(res.data.retorno.sigla !== ''){
        setShowChat(true)
        iniciarConversa();
      }       
    }).catch(err => {
      console.log(err);
    })
    setLoading(false);
  }, [])

  const lastMessageRef = useRef(null);

  useEffect(() => {
    if (!chat.length) return;

    const lastMsg = chat[chat.length - 1];
    if (lastMessageRef.current) {
      if (lastMsg.dono) {
        lastMessageRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
      } else {
        lastMessageRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [chat]);

  function iniciarConversa(){
    setLoadingChat(true)
    api.post('/destinationinit')
    .then((res) => {
      const ret = {
          dono: false,
          nome: 'Cibele',
          mensagem: res.data.retorno.mensagem
        };

        setFaqs(res.data.retorno.faqs);
        setFaqsHistory(prevHistory => [...prevHistory, res.data.retorno.faqs]);
        setChat(prevChat => [...prevChat, ret]);
        setChatOpen(true)
    }).catch(err => {
      console.log(err);
    })
    setLoadingChat(false);
  }

  // useEffect(() => {
  //   scrollDown();
  // }, [chat]);

  const scrollDown = () => {
    console.log('scroll down full called')
    if (chatScroll.current) {
      chatScroll.current.scrollTop = chatScroll.current.scrollHeight;
    }
  };


  function handleMessageChange(e) {
    setMessage(e.target.value);
  }

  function sendMessage() {
    console.log(message, 'enviando');
    if (message === '') {
      return;
    }


    setLoadingChat(true);

    setChat(prevChat => [
        ...prevChat,
        {
          dono: true,
          nome: user.nome,
          mensagem: message
        }
    ]);

    setMessage('');

    api.post('/askdestination/', { message, historyconversation: chat, historyfaqs: faqsHistory })
      .then(res => {
        const ret = {
          dono: false,
          nome: 'Cibele',
          mensagem: res.data.retorno.mensagem
        };

        setFaqs(res.data.retorno.faqs);
        setFaqsHistory(prevHistory => [...prevHistory, res.data.retorno.faqs]);
        setChat(prevChat => [...prevChat, ret]);

        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      })
      .finally(() => {
        setLoadingChat(false)
      })
  }

 
  function goDestination(){
    navigate('/destination/')
  }

  function toggleChat(){
    setChatOpen(!chatOpen);
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); 
      sendMessage();
    }
  };

  const bgStyleBox = {
    backgroundImage: `url(${bg_box})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    overflow: 'hidden',
  };

  const bgMain = {
    backgroundImage: `url(${bg_main})`,
        backgroundSize: 'cover',
    backgroundPosition: 'center',
    overflow: 'hidden'
  };
  const bgChatStyle = {
    backgroundImage: `url(${bgchat})`,
    backgroundPosition: 'center',
    overflow: 'hidden'
  };

  let dayArr = {};

  return (
    <>
      <div className={styles.chat} 
        style={{
        height: chatOpen ? "500px" : "120px",
        bottom: chatOpen ? "20px" : "-80px",
        display: showChat ? "block" : "none"
      }}
      >

        <div className={styles.chatWrapper}>

            <h5>
              <span>Dúvidas sobre o destino?</span>
              <div style={{ display: "flex", gap: "2px" }}>

              <span
                className={styles.direction}
                data-tip="Aumentar"
                onClick={toggleChat}
                >
                <MdOutlineOpenInFull />
                </span>
              
              <span
                className={styles.direction}
                data-tip="Ir para destino"
                onClick={goDestination}
                >
                <BiSolidDirections />
                </span>
              </div>

            </h5>
          <div ref={chatScroll} className={styles.chatArea}>              
    

            <>
            {chat.map((c, idx) => {
              const isLast = idx === chat.length - 1;
              return (
                <div
                  key={idx}
                  ref={isLast ? lastMessageRef : null} // attach ref only to last message
                  className={`${c.dono ? styles.messageUser : styles.messageAdmin} ${styles.message}`}
                >
                  {c.dono ? (
                    <span dangerouslySetInnerHTML={{ __html: c.mensagem }} />
                  ) : (
                    <>
                      <span className={styles.nome}>{c.nome}</span>
                      <span dangerouslySetInnerHTML={{ __html: c.mensagem }} />
                    </>
                  )}
                </div>
              );
            })}

            </>

          </div>
          {chatOpen ?                    
              <div className={styles.inputMessage} >
                <textarea onKeyDown={handleKeyDown} value={message} onChange={handleMessageChange} placeholder='Escreva sua mensagem'></textarea>
                <div className={styles.inputButton}>
                    { loadingChat ? <div className={styles.loadingChat}><AiOutlineLoading3Quarters/></div> :
                    <>
                    <button className={styles.buttonMessage} onClick={sendMessage}><AiOutlineSend /></button>
                    </>                            
                    }                          
                  </div>
              </div>
            :
            ''
          }        
        </div>
      </div>

    </>
  );
}

export default BrainChat;
